<template>
  <div>
    <Modal v-model="showCreate" :mask-closable="false" :closable="false" title="创建产品">
      <Form ref="createform" :label-width="80" :model="form" :rules="rule">
        <FormItem label="设计者" prop="c设计者">
          <Input v-model="form.c设计者" placeholder="请输入"></Input>
        </FormItem>
        <FormItem label="事业部" prop="causeDepartment">
          <Select disabled v-model="form.causeDepartment">
            <Option>----</Option>
            <Option v-for="item in causeDepartmentList" :value="item.value" :key="item.value">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="客户简名" prop="c客户名称">
          <Select v-model="form.c客户名称" filterable :remote-method="remoteMethod1" :loading="loading1">
            <Option v-for="(option, index) in c客户List" :value="option.value" :key="index">{{option.label}}</Option>
          </Select>
        </FormItem>
        <FormItem label="产品名称" prop="c模具名称">
          <Input v-model="form.c模具名称" placeholder="请输入"></Input>
        </FormItem>
        <FormItem label="型号" prop="c模具型号">
          <Input v-model="form.c模具型号" placeholder="请输入"></Input>
        </FormItem>
        <FormItem label="数量" prop="c数量">
          <Input v-model="form.c数量" placeholder="请输入"></Input>
        </FormItem>

        <FormItem label="类型" prop="c类型">
          <Input v-model="form.c类型" placeholder="请输入"></Input>
        </FormItem>
        <FormItem label="计划完成时间" prop="c计划完成时间">
          <DatePicker type="date" v-model="form.c计划完成时间" placeholder="请选择" style="width: 100%" />
        </FormItem>
        <FormItem label="售后类型" prop="c售后类型">
          <Select v-model="form.c售后类型">
            <Option v-for="item in c售后类型List" :value="item.value" :key="item.value">{{ item.name }}</Option>
          </Select>
        </FormItem>

      </Form>
      <div slot="footer">
        <Button @click="cancel" class="close-btn">取消</Button>
        <Button @click="ok" type="primary" class="close-btn">提交</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import { getAfterSaleType, createDie, getCustomers } from '../../../api/index'

export default {
  props: {
    showCreate: {
      type: Boolean,
      // required: true,
      default: false,
    },
    causeDepartmentList: {
      type: Array,
    },
    /** 由路由 ODM/OEM/RD 决定，与 PostSaleList 查询默认一致 */
    defaultCauseDepartment: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      loading1: false,
      c售后类型List: [],
      form: {
        c客户名称: '',
        c模具名称: '',
        c模具型号: '',
        c计划完成时间: '',
        c数量: '',
        c类型: '',
        c设计者: '',
        c售后类型: 0,
        causeDepartment: '',
      },
      c客户List: [],
      rule: {
        c客户名称: [{ required: true, message: '请输入', trigger: 'blur', type: 'string' }],
        c模具名称: [{ required: true, message: '请输入', trigger: 'blur', type: 'string' }],
        c模具型号: [{ required: true, message: '请输入', trigger: 'blur', type: 'string' }],
        c计划完成时间: [{ required: true, message: '请输入', trigger: 'blur', type: 'date' }],
        c数量: [{ required: true, message: '请输入', trigger: 'blur', type: 'string' }],
        c类型: [{ required: true, message: '请输入', trigger: 'blur', type: 'string' }],
        c设计者: [{ required: true, message: '请输入', trigger: 'blur', type: 'string' }],
        c售后类型: [{ required: true, message: '请输入', trigger: 'blur', type: 'number' }],
        causeDepartment: [{ required: true, message: '请选择', trigger: 'blur', type: 'number' }],
      },
      queryoption: {
        customerName: '',
        departmentType: null,
      },
    }
  },

  mounted() {
    this.getAfterSaleType()
  },
  watch: {
    showCreate(val) {
      if (val && this.defaultCauseDepartment != null) {
        this.$nextTick(() => {
          this.form.causeDepartment = this.defaultCauseDepartment
        })
      }
    },
  },
  methods: {
    async remoteMethod1(query) {
      if (query !== '') {
        this.queryoption.customerName = query
        if (this.form.causeDepartment && this.form.causeDepartment > 0) {
          this.queryoption.departmentType = this.form.causeDepartment
        }
        this.loading1 = true
        let { data } = await getCustomers(this.queryoption)
        this.loading1 = false
        let list = data.result.map((item) => {
          return {
            value: item,
            label: item,
          }
        })
        this.c客户List = list //= list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);
      } else {
        this.c客户List = []
      }
    },
    ok() {
      let _this = this
      this.$refs['createform'].validate(async (valid) => {
        if (valid) {
          await createDie(_this.form)
          this.$Message.success('新增成功')
          this.$refs['createform'].resetFields()
          this.$parent.closeShowAfterSale()
          this.$parent.getpage()
        } else {
        }
      })
    },
    cancel() {
      this.$refs['createform'].resetFields()
      this.$parent.closeShowAfterSale()
    },
    async getAfterSaleType() {
      const { data } = await getAfterSaleType()
      //  console.log("🚀 ~ file: createSale.vue:84 ~ getAfterSaleType ~ data", data)
      this.c售后类型List = data.result.statusList
      console.log(
        '🚀 ~ file: createSale.vue:88 ~ getAfterSaleType ~ this.c售后类型List',
        this.c售后类型List
      )
    },
  },
}
</script>
